import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import * as ContentActions from '../../../../../actions/content'
import { ACL } from '../../../../../constants'
import * as MediaSelectors from '../../../../../reducers/content/media/selectors'
import { Loader } from '../../../../../components'
import Button, { Sizes as ButtonSizes } from '../../../../../components/Button'
import Padding, { Sizes as PaddingSizes } from '../../../../../components/Padding'
import Media, { MediaApprovalStatusValues } from '../../../../../types/Media'
import { EstateUtils } from '../../../../../utils'
import MediaApproval from './MediaApproval'
import MediaTesting from './MediaTesting'

interface MediaApprovalsProps {
    isWorking?: boolean
}

export default function MediaApprovals(props: MediaApprovalsProps): React.ReactElement {
    const { isWorking = false }: MediaApprovalsProps = props

    const dispatch = useDispatch()
    const { t } = useTranslation()
    const selectedMedia: Media = useSelector(MediaSelectors.selectedMedia)
    const canApproveMedia: boolean = useSelector((state) => EstateUtils.hasPermission(state, { acls: [ACL.APPROVE_MEDIA] }))

    const { id: mediaId, is_approved: isApproved }: Media = selectedMedia || {}

    const isApprovalApproved: boolean = isApproved === MediaApprovalStatusValues.Approved

    const onRequestApprovalClick = (): void => {
        dispatch(ContentActions.requestMediaApproval(mediaId, false))
    }

    if (isWorking) {
        return <Loader />
    }

    return (
        <>
            <MediaApproval />
            {isApprovalApproved && <MediaTesting />}
            {!canApproveMedia && (
                <Padding top size={PaddingSizes.md}>
                    <Button size={ButtonSizes.lg} theme="secondary" onClick={onRequestApprovalClick}>
                        {t('media-request-testing')}
                    </Button>
                </Padding>
            )}
        </>
    )
}
